import { useEffect } from 'react';
import useCustomAnalytics from './use-custom-analytics';

const useScrollTrackerAnalytics = () => {
  const { trackScroll } = useCustomAnalytics();

  // scroll event fire at 90%

  useEffect(() => {
    window.addEventListener('scroll', trackScroll);
    return () => window.removeEventListener('scroll', trackScroll);
  }, []);
};

export default useScrollTrackerAnalytics;
